module.exports = "/img/_/_/_/assets/images//frame_friend.png?f2e21329701baadb978397939274e387";